import React from 'react';
import clsx from 'clsx';
import { TitleImage, TopButton } from "../AboutPageGeneralComp"
import DesignPageSection from '../DesignPageSection/DesignPageSection';

/**
 * This component renders the second section of the main markdown that is rendered 
 * in aboutPage page.
 */
const MarkdownBodySection2 = ({refArray, elSubRefs}) => (
    <>
        <CreateNewPageSection myRef={refArray[3]}/>
        <DesignPageSection myRef={refArray[4]} elSubRefs={elSubRefs}/>   
        <PageFlowSection myRef={refArray[5]}/>
        <FormsSection myRef={refArray[6]}/>
        <AnnotateSection myRef={refArray[7]}/>
        <br />
        <br />
        <TopButton myRef={refArray[0]} />
        <br/>
    </>
)

//  This component renders page flow section
const PageFlowSection = ({myRef}) => (
    <section ref={myRef} id="Group5" className={clsx("group")}>
        <h3 id="Group9">Page Flow</h3><br />
        <TitleImage 
            title='You can add links between your pages. To do so, please select an item that you want to link and click on the Edit icon.'
            srcImg= '/images/AboutPageMarkdownImg/page-flow_1.jpg' 
        />
        <TitleImage
            title='Select the "Product" page from the "Go to project page" section.'
            srcImg= '/images/AboutPageMarkdownImg/page-flow_3.jpg' 
        />
        <TitleImage
            title='You have now created the link and you can view the page flow by selecting the "View page data flow" from the top right menu.' 
            srcImg= '/images/AboutPageMarkdownImg/page-flow_4.jpg'      
        />
        <TitleImage
            title='You can now see the flow of your pages. Try adding new pages and creating links between those pages.'
            srcImg= '/images/AboutPageMarkdownImg/page-flow_5.jpg'
        />
    </section>   
)

//  This component renders forms section.
const FormsSection = ({myRef}) => (
    <section ref={myRef} id="Group10" className={clsx("group")}>
        <h3 id="Group6">Creating new Forms</h3><br />
        <TitleImage
            title='Duplicate your page by clicking on the Duplicate icon.'
            srcImg= '/images/AboutPageMarkdownImg/duplicate_page_1.jpg'
        />
        <TitleImage
            title='Set a new name for your page.'
            srcImg= '/images/AboutPageMarkdownImg/duplicate_page_2.jpg'
        />  
        <TitleImage 
            title='Insert a "Text" block element.'
            srcImg= '/images/AboutPageMarkdownImg/form_1.jpg'
        />          
        <TitleImage
            title='From the "Data" tab on the left menu, select "Create" "new data element".'
            srcImg= '/images/AboutPageMarkdownImg/form_2.jpg'
        />
        <TitleImage
            title='Select a name for your new data element and select the "Add new rows" in your forms.'
            srcImg= '/images/AboutPageMarkdownImg/form_3.jpg'
        />
        <TitleImage
            title='Below you can see an example of how to create new rows into your forms.'
            srcImg= '/images/AboutPageMarkdownImg/form_4.jpg'
        />
        <TitleImage
            title='After you finish adding rows you can click the Generate button.'
            srcImg= '/images/AboutPageMarkdownImg/form_5.jpg'
        />
        <TitleImage
            title='You have now created a new custom block item. In order to insert this item into your canvas you need to go to your extra Block elements and Drag and Drop your custom block inside your canvas.'
            srcImg= '/images/AboutPageMarkdownImg/form_6.jpg' 
        />
        <br />
    </section>   
)

//  This component renders annotate section.
const AnnotateSection = ({myRef}) => (
    <section ref={myRef} id="Group11" className={clsx("group")}> 
        <h3 id="Group7">Data model</h3><br />
        <TitleImage
            title='You can now easily create the data model for your pages. Go to your home page and select an element that you wish to annotate. Click on the Edit button.'
            srcImg= '/images/AboutPageMarkdownImg/annotate_1.jpg'
        />
        <TitleImage
            title='See an example below of how you can annotate the title of a product.'
            srcImg= '/images/AboutPageMarkdownImg/annotate_3.jpg'
        />
        <TitleImage 
            title='Do the same for the price.'
            srcImg= '/images/AboutPageMarkdownImg/annotate_4.jpg'
        />
        <TitleImage 
            title='And for the photo.'
            srcImg= '/images/AboutPageMarkdownImg/annotate_5.jpg'
        />
        <TitleImage
            title='In order to view your page data model you can now click on the "View page data model" icon from the top right menu.'
            srcImg= '/images/AboutPageMarkdownImg/annotate_6.jpg'
        />
        <TitleImage 
            title='You can now view your page data model!'
            srcImg= '/images/AboutPageMarkdownImg/annotate_7.jpg'
        />                             
        <br />   
    </section>   
)

//  This component renders create new page section.
const CreateNewPageSection = ({myRef}) => (
    <section ref={myRef} id="Group7" className={clsx("group")}>
        <h3 id="Group3">Create new page</h3><br />
        <TitleImage
            title='You can create a new page by clicking on the "+" button.'
            srcImg= '/images/AboutPageMarkdownImg/4.jpg'
        />
        <TitleImage 
            title='Name your page and click "Create" button.'
            srcImg= '/images/AboutPageMarkdownImg/5.jpg'
        />         
        <br />   
    </section>   
)


export default MarkdownBodySection2;